import axios from "axios";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../..";

export const addUser = async ({ name, email, topValues }) => {
  await addDoc(collection(db, "users"), {
    name: name,
    email: email,
    topValues: topValues,
  }).catch((err) => {
    //console.log(err);
  });
};

export const submitForm = async (email, firstname, lastname) => {
  //YOUB CREDENTIALS
  //portalId="21744358"
  //formId="69da2649-a6b8-4031-bf27-bf8f23b55b48"

  //TEST CREDENTIALS
  /* const portalId = "22392178";
  const formGuid = "95642f39-7d4a-4036-9dd4-61c731d8f0e1"; */

  const portalId = "21744358";
  const formGuid = "69da2649-a6b8-4031-bf27-bf8f23b55b48";
  const config = {
    // important!
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.post(
    `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
    {
      portalId,
      formGuid,
      fields: [
        {
          name: "firstname",
          value: firstname,
        },
        {
          name: "lastname",
          value: lastname,
        },
        {
          name: "email",
          value: email,
        },
      ],
    },
    config
  );
  //console.log(response);
  return response;
};
